import {
  AppConstants,
  conceptCodes,
  JUKServices,
  MLY_IDS,
  MLY_SERVICE_TEXT,
  SESSION_FILES_UPLOAD,
  sharedStateKeys,
  stepTypes,
} from "../../../../constants/constant";
import {
  FormValues,
  SchedulerConfig,
} from "../../../../Interface/scheduler/form";
import { UtmCampaign, getCampaignName } from "./UtmCampaign";
import BookingPayloadInterface from "../../../../service/model/BookingPayloadInterface";
import { generateNotes } from "../../../../utility/generateNotes";
import { generateHTMLEstimateNotes } from "../../../../utility/generateHTMLEstimateNotes";
import {
  getFirstValueFromObj,
  sessionStorageUtils,
} from "../../../../utility/utility";
import { checkBrandsForPricingEstimate } from "../../../../utility/checkBrandsForPricingEstimate";
import {
  updateCommercialDetails,
  updateResidentialDetails,
} from "../../../../common/components/Helper/Helper";

const BookingPayload = (
  formValues: FormValues,
  formConfig: SchedulerConfig,
  pauseLead: boolean,
  correlationID: string,
  sharedState,
  current: number,
  push5UMB17Text?: boolean,
) => {
  const selectedOffer = sessionStorage.getItem("offerDetails");
  const options: Intl.DateTimeFormatOptions = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  const offerJson = sessionStorageUtils.getItem("offerDetails");
  const validOffer = JSON.parse(offerJson);
  const {
    fname = "",
    lname = "",
    email = "",
    phone = "",
    address = "",
    address1 = "",
    address2 = "",
    zipcode = "",
    state = AppConstants.NO_STATE_FOUND,
    city = AppConstants.NO_CITY_FOUND,
    franchiseId = "",
    franchiseWebLocationId = "",
    conceptID = "",
    countryCode = "",
    conceptCode = "",
    licenseNumber = "",
    "license-number": licensePlateNumber = "",
    secondarySource = "",
    leadSourceId = 0,
    receiveupdates = "",
    businessname = "",
    servicetype = "",
    service = "",
    shelvingstorage = "",
    floor = "",
    serviceText = "",
    vin = "",
    modelYear = "",
    make = "",
    model = "",
    bodyClass = "",
    serviceTypeID = "",
    optIn = false,
    emailOptOut = false,
    selectedPriceQuoteSkuIds = [],
    manufacturerWarranty = "",
    applianceBrand = {},
    serviceName = "",
    technicianIds = "",
    isMlyFlow = false,
    alreadySentToBroadly = false,
  }: FormValues = formValues;
  const primarySource = sessionStorage.getItem("primarySource");

  let scheduleId: string = "";
  const appendSchedule =
    formConfig.steps[current]?.steptype === stepTypes.REQUEST_TIME_TYPE &&
    current === 1 &&
    formConfig.conceptCode === conceptCodes.DVW_CONCEPT_CODE;
  if (!appendSchedule) scheduleId = formValues?.scheduleId;
  let warranty: boolean;
  if (
    manufacturerWarranty === "yes" ||
    sharedState[sharedStateKeys.IS_WARRANTY]
  ) {
    warranty = true;
    scheduleId = "";
  }
  let jobPromisedDate = "";
  if (scheduleId != "") {
    jobPromisedDate = formValues?.date;
  } else {
    jobPromisedDate = new Intl.DateTimeFormat("en-US", options).format(
      new Date(),
    );
  }

  //Generate note for payload and for displaying in appointment side card
  const { note, displayNotesForServiceDesc, displayDisclaimer } = generateNotes(
    formValues,
    formConfig,
    pauseLead,
    selectedOffer,
    optIn as boolean,
    emailOptOut as boolean,
    warranty as boolean,
    push5UMB17Text,
  );

  const estimateNote = generateHTMLEstimateNotes(
    sharedState[sharedStateKeys.PRICE_QUOTE_ESTIMATION_OBJECT],
    sharedState[sharedStateKeys.NON_PRICABLE_QUOTE_ESTIMATION_OBJECT],
    formValues,
  );

  sessionStorage.setItem("serviceDescription", displayNotesForServiceDesc);
  if (displayDisclaimer) {
    sessionStorage.setItem("serviceDescriptionDisclaimers", displayDisclaimer);
  }
  const howDidYouHearAboutUs =
    primarySource && secondarySource
      ? `${primarySource}: ${secondarySource}`
      : primarySource || "";
  const isLeadOnly = scheduleId != "" ? false : true;
  const campaign = sessionStorage.getItem("campaignName");
  const urlParams = getCampaignName();
  const campaignName = urlParams ? urlParams : campaign || "N/A";
  const referringURL = document.referrer || "N/A";
  const fileUrls = sessionStorageUtils.getItem(SESSION_FILES_UPLOAD);
  const formattedFileUrls = fileUrls
    ? JSON.parse(fileUrls)?.map((url: string) => ({ fileUrl: url }))
    : [{ fileUrl: undefined }];
  const servicesArray = [
    ...(formValues?.serviceRequested || []),
    ...(formValues[AppConstants.VEHICLE_REPAIR_ID] || []),
  ];

  const formattedServiceRequested =
    servicesArray.length > 0 ? servicesArray : [];

  const customLeadSourceDefault = sessionStorage.getItem(
    "customLeadSourceDefault",
  );
  const elements = formConfig?.steps.find(
    (step) => step.steptype === AppConstants.HOW_WE_CAN_REACH,
  )?.elements;
  let isShelfCloset = false;
  if (elements) {
    elements?.forEach((element) => {
      if (element.type === AppConstants.AGNOSTIC_FORM) {
        element?.fields?.forEach((field) => {
          if (field.id === AppConstants.SHELF_STORAGE_ID) {
            isShelfCloset = true;
          } else {
            if (formValues?.shelfStorageConfigure) {
              if (
                formValues.onlineScheduling &&
                !formValues.offersClosetAppointments
              ) {
                isShelfCloset = true;
              }
            }
          }
        });
      }
    });
  }
  let isDumpster: boolean | string = "";

  if (serviceName === JUKServices.DUMPSTER_RENTAL) {
    isDumpster = true;
  } else if (serviceName === JUKServices.FULL_SERVICE_JUNK_REMOVAL) {
    isDumpster = false;
  } else {
    isDumpster = "";
  }
  const leadSourceIdVal = Number(leadSourceId)
    ? Number(leadSourceId)
    : formValues?.configLeadSourceId || 0;
  const payload: BookingPayloadInterface = {
    franchiseId: Number(franchiseId),
    isBetaTester: false,
    isLocalized: true,
    conceptId: Number(conceptID) || Number(formConfig?.conceptid),
    c4ChannelTypeId: 0,
    conceptCalledId: Number(conceptID) || Number(formConfig?.conceptid),
    conceptCode: (conceptCode as string) || (formConfig?.conceptCode as string),
    correlationId: correlationID || "",
    c4LeadsEnabled: true,
    vendorId: formConfig.vendorId ? Number(formConfig.vendorId) : 82,
    nationalLeadId: "",
    isTest: true,
    vendorName: formConfig?.vendorName,
    webLocationId: Number(franchiseWebLocationId),
    c4CallCenterId: 0,
    note: note,
    zipCode: zipcode?.trim() as string,
    firstName: fname?.trim() as string,
    lastName: lname?.trim() as string,
    email: email?.trim() as string,
    phone: phone as string,
    postalCode: zipcode as string,
    city: city as string,
    state: state as string,
    country: countryCode as string,
    address: (address1 as string) ? (address1 as string) : (address as string),
    address2: address2 as string,
    leadSource: "Web",
    leadOrigin: "Web",
    campaignName: campaignName,
    referringURL: referringURL,
    currentPage: window.location.href,
    callType: "In Bound",
    preferredCommunicationType: "",
    emailOptOut: emailOptOut ? (emailOptOut as boolean) : false,
    leadSourceId: leadSourceIdVal,
    secondaryLeadSourceId: 0,
    serviceTypeProblem: "",
    overrideJobPromisedDate: "",
    optIn: optIn ? (optIn as boolean) : false,
    isLeadOnly: isLeadOnly,
    timeBlock: {
      conceptId: Number(conceptID) || Number(formConfig?.conceptid),
      googleCalendarEventId: "",
      googleCalendarEmail: "",
      timeSlotTypeId: 0,
      isEstimate: false,
      jobPromisedDate: jobPromisedDate,
      isAvailable: true,
      isFranchiseInPOS: true,
      displayText: "",
    },
    callId: "",
    customerType: servicetype
      ? (servicetype as string)
      : AppConstants.RESIDENTIAL_TEXT,
    leadAdditionalNotes: {
      leadAdditionalNoteLabel: "Website",
      leadAdditionalNoteText: "",
    },
    scheduleID: scheduleId != "" ? (scheduleId as string) : "",
    howDidYouHearAboutUs: howDidYouHearAboutUs
      ? howDidYouHearAboutUs
      : customLeadSourceDefault || "",
    signUpForUpdates: receiveupdates === "yes" ? true : false,
    serviceRequested: formattedServiceRequested,
    businessName: businessname ? (businessname as string) : "",
    serviceType: isShelfCloset
      ? shelvingstorage || AppConstants.SHELF_CLOSET_DEFAULT
      : "",
    floor: floor ? (floor as string) : "",
    fileUrls: formattedFileUrls,
    estimateNote: estimateNote,
    itemList: "",
    howheard: "",
    appointmentTypeID: "1",
    userAgent: "A Neighborly UA",
    howheardother: "",
    landingPage: "",
    referringPage: "",
    AdditionalInfo: "",
    isDumpster: isDumpster,
    couponCode: "",
    jobFrequency: formValues["frequency-of-cleaning"],
    estimateSquareFeet: formValues?.["square-feet"],
    estimateBedrooms: formValues?.bedrooms,
    estimateBathrooms: formValues?.bathrooms,
    jobFrequencyDetail: formValues?.["recurring-schedule"],
  };

  //Block Broadly automation for nearby leads when enabled in brand config, so the lead isn't sent to Broadly for nurturing
  if (alreadySentToBroadly) {
    payload.alreadySentToBroadly = true;
  }

  if (isMlyFlow) {
    payload.isEstimate = false;
    if (formValues[MLY_IDS.SERVICE] === MLY_IDS.RESIDENTIAL) {
      if (formValues[MLY_IDS.FREQUENCY] === MLY_IDS.ONE_TIME_CLEAN) {
        payload.serviceText = MLY_SERVICE_TEXT.ONE_TIME_CLEAN;
      } else {
        payload.isEstimate = true;
        payload.serviceText = MLY_SERVICE_TEXT.ESTIMATE;
      }
    } else if (
      formValues[MLY_IDS.SERVICE] === MLY_IDS.COMMERCIAL &&
      formValues[MLY_IDS.COMMERCIAL_FREQUENCY] === MLY_IDS.COMMERCIAL_RECURRING
    ) {
      payload.isEstimate = true;
    }
    if (current === 0 || formValues.isCallBackEnabled)
      payload.serviceText = MLY_SERVICE_TEXT.LEAD_ONLY;
  }

  if (serviceText) {
    payload.serviceText = serviceText;
  }
  if (formConfig.conceptCode === conceptCodes.RPM_CONCEPT_CODE) {
    if (formConfig?.serviceText) {
      payload.serviceText = formConfig.serviceText;
    }
    payload.DayTimePhoneNumber = phone;
  }
  if (
    formConfig?.conceptCode === conceptCodes.JUK_CONCEPT_CODE &&
    validOffer &&
    (validOffer.couponcode || validOffer.couponCode)
  ) {
    const promo = validOffer.couponcode || validOffer.couponCode;
    payload.couponCode = `pcode:${promo}`;
  }
  if (licenseNumber) {
    payload.licenseNumber = licenseNumber as string;
  }
  if (licensePlateNumber) {
    payload.licensePlateNumber = licensePlateNumber as string;
  }
  if (formValues?.paymentSelection === AppConstants.PERSONAL_PAYMENT) {
    payload.formOfPayment = formValues[AppConstants.PAYMENT_LABEL];
  } else if (formValues?.paymentSelection === AppConstants.INSURANCE_PAYMENT) {
    payload.insuranceCompany = formValues[AppConstants.INSURANCE_COMPANY_NAME];
    payload.policyNumber = formValues[AppConstants.POLICY_NUMBER];
    payload.deductibleAmount = Number(
      formValues[AppConstants.DEDUCTABLE_AMOUNT_VALUE],
    );
  }
  const firstWdgSkuId = getFirstValueFromObj(selectedPriceQuoteSkuIds);
  if (service || formValues?.serviceRequestImage) {
    const serviceSkuId = formValues?.serviceRequestImage?.[0]?.serviceid;
    payload.serviceSkuId = Number(service || serviceSkuId) || 0;
    payload.timeBlock = {
      ...payload.timeBlock,
      serviceSkuId: Number(serviceSkuId) || 0,
    };
  } else if (firstWdgSkuId) {
    //WDG Price Quote
    payload.serviceSkuId = Number(firstWdgSkuId);
  }
  const leadAdditionalNoteLabel = UtmCampaign();
  if (leadAdditionalNoteLabel) {
    payload.leadAdditionalNotes.leadAdditionalNoteLabel =
      leadAdditionalNoteLabel;
  }
  if (vin) {
    payload.vin = vin as string;
  }
  if (modelYear && make && model && bodyClass) {
    payload.year = Number(modelYear);
    payload.make = make as string;
    payload.model = model as string;
    payload.bodyStyle = bodyClass as string;
  }
  if (serviceTypeID) {
    payload.serviceTypeID = Number(serviceTypeID);
  }

  if (applianceBrand && applianceBrand?.makeId) {
    payload.makeId = Number(applianceBrand.makeId);
  }
  if (
    sharedState[sharedStateKeys.IS_PAUSE_LEAD] &&
    !checkBrandsForPricingEstimate(formConfig.conceptCode)
  ) {
    payload.pauseLead = true;
  }
  if (sharedState[sharedStateKeys.SERVICE_REQUEST_TYPE]) {
    payload.serviceType = sharedState[sharedStateKeys.SERVICE_REQUEST_TYPE];
  }
  if (sharedState[sharedStateKeys.SERVICE_REQUEST_PROPERTY]) {
    payload.serviceProperty =
      sharedState[sharedStateKeys.SERVICE_REQUEST_PROPERTY];
  }
  if (sharedState[sharedStateKeys.SERVICE_REQUEST_ID]) {
    payload.serviceId = Number(sharedState[sharedStateKeys.SERVICE_REQUEST_ID]);
  }
  if (technicianIds) {
    payload.technicianIds = technicianIds;
  }
  updateResidentialDetails(payload, formValues);
  updateCommercialDetails(payload, formValues);
  return payload;
};
export default BookingPayload;
